import script from "./Middle.vue?vue&type=script&setup=true&lang=ts"
export * from "./Middle.vue?vue&type=script&setup=true&lang=ts"

import "./Middle.vue?vue&type=style&index=0&id=add967ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add967ea"]])

export default __exports__